import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useApplicationUid from '../../hooks/useApplicationUid';
import { downloadAgreement } from '../../store/actions/agreement/agreementActions';
import { selectAgreement } from '../../store/selectors/agreementSelectors';
import { selectIsLoadingByActionType } from '../../store/selectors/loadingSelectors';
import { DOWNLOAD_AGREEMENT_LOADING } from '../../store/actions/agreement/agreementActionConstants';
import SectionLoader from '../SectionLoader/SectionLoader';
import themeColors from '../../assets/styles/themeColors';

const AgreementWrap = styled.div`
  min-height: 300px;
  height: 100%;

  .ps-contract {
    display: block !important;

    div,
    p {
      font-size: 16px !important;
    }
  }

  .ps-contract-scroll {
    max-height: 100% !important;
    overflow: none !important;
  }

  .ps-contract-body,
  .ps-contract {
    padding: 0 !important;
    border-width: 0 !important;
  }

  .ps-contract-title,
  .ps-contract-options,
  .ps-checkbox-container {
    display: none !important;
  }

  h2 {
    text-align: center !important;
  }

  h2,
  h3 {
    font-weight: 600 !important;
    margin-bottom: 1.5rem !important;
    margin-top: 0 !important;
  }

  p {
    margin-bottom: 1.5rem !important;
    margin-top: 0 !important;
  }

  a {
    color: ${themeColors.colorTextSecondary};
    text-decoration: underline !important;
    font-weight: 600;
    font-size: inherit;
  }
`;

const EquityAgreementDisplay = ({ type }) => {
  const { ApplicationUid } = useApplicationUid();
  const agreement = useSelector(selectAgreement);
  const dispatch = useDispatch();

  const isLoading = useSelector(
    selectIsLoadingByActionType(DOWNLOAD_AGREEMENT_LOADING),
  );

  useEffect(() => {
    dispatch(
      downloadAgreement({
        type,
        ApplicationUid,
      }),
    );
  }, [ApplicationUid, dispatch, type]);

  return (
    <AgreementWrap>
      <SectionLoader isLoading={isLoading}>
        {ReactHtmlParser(agreement)}
      </SectionLoader>
    </AgreementWrap>
  );
};

EquityAgreementDisplay.propTypes = {
  type: PropTypes.string,
};

export default EquityAgreementDisplay;
